<div class="progress-bar-container">
    <div class="progress-bar" [style.width]="progress+'%'"></div>
</div>
